import { NgOptimizedImage } from '@angular/common'
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { RouterLink } from '@angular/router'

import { InputNumberModule } from 'primeng/inputnumber'
import { TagModule } from 'primeng/tag'

import { CustomInput } from 'app/_shared/interfaces/Product'
import { DisplayCurrency } from 'app/_shared/interfaces/display-currency'
import { UsdPipe } from 'app/_shared/pipes/currency.pipe'
import { PricePipe } from 'app/_shared/pipes/price.pipe'

export interface CartItemModel {
  product_size_id: number | null
  product_variant_id: number
  slug: string
  name: string
  recipient_name?: string
  email?: string
  image?: string | null
  size: string | number
  color?: string | null
  is_gift_card?: number
  input_fields?: CustomInput[]
  price: number
  quantity: number
  minimum_order_quantity?: boolean
  minimum_order_quantity_amount?: number | null
}

@Component({
  selector: 'app-cart-item',
  standalone: true,
  imports: [
    RouterLink,
    TagModule,
    InputNumberModule,
    FormsModule,
    PricePipe,
    UsdPipe,
    NgOptimizedImage
  ],
  templateUrl: './cart-item.component.html',
  styleUrl: './cart-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CartItemComponent {
  displayCurrency = input<DisplayCurrency | null | undefined>(undefined)
  item = input.required<CartItemModel>()
  removeIndex = input.required<number>()
  inactive = input<boolean>(false)
  disablePrices = input<boolean>(false)
  hidePrices = input<boolean>(false)
  isGifting = input<boolean>(false)
  readonly = input<boolean>(false)
  isCheckout = input(false)

  remove = output<number>()
  quantityChange = output<{ index: number; value: number }>()

  onRemove() {
    this.remove.emit(this.removeIndex())
  }

  get minQuantity(): number {
    const current = this.item()
    if (current?.minimum_order_quantity && current?.minimum_order_quantity_amount) {
      return current.minimum_order_quantity_amount
    }
    return 1
  }

  onQuantityChange(value: number) {
    const v = Math.max(this.minQuantity, Number(value) || this.minQuantity)
    this.quantityChange.emit({ index: this.removeIndex(), value: v })
  }

  getInputDisplayValue({ type, value }: CustomInput): string {
    return type === 'toggle' ? (value ? 'On' : 'Off') : value ? String(value) : '—'
  }
}
